module.exports = __webpack_public_path__ + "media/src/images/media_logo-42f8097078f7e03d18497b3e5892488a.svg";